export default "__VITE_ASSET__DPx55VEv__"